import Login from './components/Login.vue'
import VerificationCode from './components/verificationCode.vue'
import LoginHCPAdmin from './components/LoginHCPAdmin.vue'
import LoginAccountAdmin from './components/LoginAccountAdmin.vue'
import LoginHCPClinic from './components/LoginHCPClinic.vue'
import hcpLogin from './components/hcpLogin.vue'
import PatientList from './components/PatientList.vue'
import HcpMenu from './components/HcpMenu.vue'
import HcpUserManagement from './components/HcpUserManagement.vue'
import HcpGroupUserInfo from './components/profile-templates/HcpGroupUserInfo.vue'
import HcpOperationHistory from './components/HcpOperationHistory.vue'
import HcpAddUser from './components/profile-templates/HcpAddUser.vue'
import ClinicPatientList from './components/ClinicPatientList.vue'
import Sign from './components/Sign.vue'
import hcpSign from './components/hcpSign.vue'
import Hcp from'./components/HCP.vue'
import ClinicHcp from'./components/ClinicHCP.vue'
import newPatient from'./components/newPatient.vue'
import findPatient from'./components/findPatient.vue'
import updatePassword from './components/updatePassword.vue'
import personalApply from './components/personalApply.vue'


//登录注册头尾组件 待优化
import headerComponent from './components/common-template/Header.vue'
import footerComponent from './components/common-template/Footer.vue'
import AccountAdminHeader from './components/common-template/AccountAdminHeader.vue'
import AccountAdminFooter from './components/common-template/AccountAdminFooter.vue'
import Signheader from './components/common-template/Signheader.vue'
import Signfooter from './components/common-template/Signfooter.vue'
import HCPHeader from"./components/common-template/HCPHeader.vue"
import CreateHCPHeader from"./components/common-template/CreateHCPHeader.vue"

// 账号管理
import AccountAdminSuper from './components/AccountAdmin/AccountAdminSuper.vue'
import AccountAdminHome from './components/AccountAdmin/AccountAdminHome.vue'
import AccountAdminList from './components/AccountAdmin/AccountAdminList.vue'
import dataStatistics from './components/AccountAdmin/dataStatistics.vue'
import HCLprint from './components/AccountAdmin/dataSTS/HCLprint.vue'
import UserAdmin from './components/AccountAdmin/UserAdmin.vue'
import DevDebug from './components/AccountAdmin/DevDebug.vue'
import AccountAdminAdd from './components/AccountAdmin/AccountAdminAdd.vue'
import AccountAdminSuperAdd from './components/AccountAdmin/AccountAdminSuperAdd.vue'
import AccountAdminMainHeader from './components/AccountAdmin/AccountAdminMainHeader.vue'
import AccountAdminMainFooter from './components/AccountAdmin/AccountAdminMainFooter.vue'
import BasicQuantityRecord from './components/AccountAdmin/BasicQuantityRecord.vue'
//Hcp子路由
import charts from './components/charts.vue'
import chart0 from './components/home-template/chart0.vue'
import chart1 from './components/home-template/chart1.vue'
import chart2_2 from './components/home-template/chart2-2.vue'
import chart3 from './components/home-template/chart3.vue'
import chart4 from './components/home-template/chart4.vue'
import chart5_2 from './components/home-template/chart5-2.vue'
import chart6 from './components/home-template/chart6.vue'
import chart7 from './components/home-template/chart7.vue'
import chart8 from './components/home-template/chart8.vue'
import chart9 from './components/home-template/chart9.vue'

import refresh from './components/home-template/refresh.vue'

import chartSetting from './components/chartSetting.vue'
import setting from './components/home-template/setting.vue'
import dateView from './components/home-template/dateView.vue'
import dateView2 from './components/home-template/dateView2.vue'

import monitor from './components/monitor.vue'
import events from './components/events.vue'
import records from './components/records.vue'
import print from './components/print.vue'
import ClinicExportData from './components/ClinicExportData.vue'

import patientProfile from './components/profile-templates/patientProfile-edit.vue'
import patientProfile2 from './components/profile-templates/patientProfile-noEdit.vue'
import patientProfile3 from './components/profile-templates/patientProfile-carer.vue'

import messages from './components/profile-templates/messages.vue'
import Profile1 from './components/profile-templates/profile-patient.vue'
import CreateHCP from './components/profile-templates/create-hcp.vue'

import RecentUpdates from './components/profile-templates/recent-updates.vue'
import changePassword from './components/profile-templates/changePassword.vue'

//监护人页面
import  carerConnect from './components/care-templates/carer-connect.vue'
import  addConnect from './components/care-templates/addConnect.vue'
import patientConnect from './components/care-templates/patient-connect.vue'

//打印页面
import  chart0_print from'./components/print-htmplate/chart0_print.vue'
import  chart1_print from'./components/print-htmplate/chart1_print.vue'
import  chart2_print from'./components/print-htmplate/chart2_print.vue'
import  chart3_print from'./components/print-htmplate/chart3_print.vue'
import  chart4_print from'./components/print-htmplate/chart4_print.vue'
import  chart5_print from'./components/print-htmplate/chart5_print.vue'
import  chart6_print from'./components/print-htmplate/chart6_print.vue'
import  chart6_print2 from'./components/print-htmplate/chart6_print2.vue'
import  chart7_print from'./components/print-htmplate/chart7_print.vue'
import  chart9_print from'./components/print-htmplate/alerts_print.vue'
import  events_print1 from'./components/print-htmplate/events_print1.vue'
import  record_print from'./components/print-htmplate/record_print.vue'

//快速打印页面
import  quickPrint1 from'./components/print-htmplate/quickPrint1.vue'
import  quickPrint2 from'./components/print-htmplate/quickPrint2.vue'
import  quickPrint3 from'./components/print-htmplate/quickPrint3.vue'
import  quickPrint4 from'./components/print-htmplate/quickPrint4.vue'
import  quickPrint5 from'./components/print-htmplate/quickPrint5.vue'
import  quickPrint6 from'./components/print-htmplate/quickPrint6.vue'
import  quickPrint7 from'./components/print-htmplate/quickPrint7.vue'
import  quickPrint8 from'./components/print-htmplate/quickPrint8.vue'
import  quickPrint9 from'./components/print-htmplate/quickPrint9.vue'
import  quickPrint10 from'./components/print-htmplate/quickPrint10.vue'



let paths = '/path';

//路由实现
const routes= [
  {
    path:'/',
    redirect:'/login'
  },
  {
    path:'/login',
    components:{
      default:Login,
      header: headerComponent, //采用命名组件实现不同页面有不同头部
      footer: footerComponent
    }
  },
  {
    path:'/verificationCode',
    components:{
      default: VerificationCode,
      header: headerComponent, //采用命名组件实现不同页面有不同头部
      footer: footerComponent
    }
  },
  {
    path:'/accountsmanagement',
    components:{
      default:LoginHCPAdmin,
      header: headerComponent, //采用命名组件实现不同页面有不同头部
      footer: footerComponent
    }
  },
  {
    path:'/managementtools',
    components:{
      default:LoginAccountAdmin,
      header: AccountAdminHeader, //采用命名组件实现不同页面有不同头部
      footer: AccountAdminFooter
    }
  },
  {
    path:'/accountsadmin_super',
    components:{
      default:AccountAdminSuper,
      header: AccountAdminMainHeader, //采用命名组件实现不同页面有不同头部
      footer: AccountAdminMainFooter
    }
  },
  {
    path:'/accountsadmin_home',
    components:{
      default:AccountAdminHome,
      header: AccountAdminMainHeader, //采用命名组件实现不同页面有不同头部
      footer: AccountAdminMainFooter
    }
  },
  {
    path:'/accountsadmin_add',
    components:{
      default:AccountAdminAdd,
      header: AccountAdminMainHeader, //采用命名组件实现不同页面有不同头部
      footer: AccountAdminMainFooter
    }
  },
  {
    path:'/accountsadmin_list',
    components:{
      default:AccountAdminList,
      header: AccountAdminMainHeader, //采用命名组件实现不同页面有不同头部
      footer: AccountAdminMainFooter
    }
  },
  {
    path:'/dataStatistics',
    components:{
      default:dataStatistics,
      header: AccountAdminMainHeader, //采用命名组件实现不同页面有不同头部
      footer: AccountAdminMainFooter
    }
  },
  {
    path:'/HCLprint',
    components:{
      default:HCLprint,
    },
  },
  {
    path:'/UserAdmin',
    components:{
      default:UserAdmin,
      header: AccountAdminMainHeader, //采用命名组件实现不同页面有不同头部
      footer: AccountAdminMainFooter
    }
  },
  {
    path:'/History',
    components:{
      default:()=>import('./components/AccountAdmin/history.vue'),
      header: AccountAdminMainHeader, //采用命名组件实现不同页面有不同头部
      footer: AccountAdminMainFooter
    }
  },
  {
    path:'/Member',
    components:{
      default:()=>import('./components/AccountAdmin/Member.vue'),
      header: AccountAdminMainHeader, //采用命名组件实现不同页面有不同头部
      footer: AccountAdminMainFooter
    }
  },
  {
    path:'/DevDebug',
    components:{
      default:DevDebug,
      header: AccountAdminMainHeader, //采用命名组件实现不同页面有不同头部
      footer: AccountAdminMainFooter
    }
  },
  {
    path:'/BasicQuantityRecord',
    components:{
      default:BasicQuantityRecord,
      header: AccountAdminMainHeader, //采用命名组件实现不同页面有不同头部
      footer: AccountAdminMainFooter
    }
  },
  {
    path:'/CreateHCP_list',
    components:{
      default:CreateHCP,
      header: AccountAdminMainHeader, //采用命名组件实现不同页面有不同头部
      footer: AccountAdminMainFooter
    }
  },
  {
    path:'/accountsadmin_super_add',
    components:{
      default:AccountAdminSuperAdd,
      header: AccountAdminMainHeader, //采用命名组件实现不同页面有不同头部
      footer: AccountAdminMainFooter
    }
  },
  {
    path:'/clinic',
    components:{
      default:LoginHCPClinic,
      header: headerComponent, //采用命名组件实现不同页面有不同头部
      footer: footerComponent
    }
  },
  {
    path:'/hcpLogin',
    components:{
      default: hcpLogin,
      header: headerComponent,
      footer: footerComponent
    }
  },
  {
    path:'/sign',
    components:{
      default:Sign,
      header:Signheader,
      footer:Signfooter
    }
  },
  {
    path:'/hcpSign',
    components:{
      default: hcpSign,
      header: Signheader,
      footer: Signfooter
    }
  },
  {
    path:'/personalApply',
    components:{
      default: personalApply,
      header: Signheader,
      footer: Signfooter
    }
  },
  {
    path:'/updatePassword',
    components:{
      default:updatePassword,
      header: Signheader,
      footer: footerComponent
    }
  },
  {
    path:'/PatientList',
    components:{
      default:PatientList,
      header:HCPHeader,
    }
  },
  {
    path:'/HcpMenu',
    components:{
      default:HcpMenu,
      header:HCPHeader,
    }
  },
  {
    path:'/HcpUserManagement',
    components:{
      default:HcpUserManagement,
      header:HCPHeader,
    }
  },
  {
    path:'/HcpGroupUserInfo',
    components:{
      default:HcpGroupUserInfo,
      header:HCPHeader,
    }
  },
  {
    path:'/HcpOperationHistory',
    components:{
      default:HcpOperationHistory,
      header:HCPHeader,
    }
  },
  {
    path:'/HcpAddUser',
    components:{
      default:HcpAddUser,
      header:HCPHeader,
    }
  },
  {
    path:'/ClinicPatientList',
    components:{
      default:ClinicPatientList,
      //header:HCPHeader,
      header:CreateHCPHeader
    }
  },
  {
    path:'/newPatient',
    components:{
      default:newPatient,
      header:HCPHeader,
    }
  },
  {
    path:'/findPatient',
    components:{
      default:findPatient,
      header:HCPHeader,
    }
  },
  {
    path: '/ClinicHcp',
    components: {
      default: ClinicHcp,
      header: CreateHCPHeader,
     },
    children: [
      { path:'/ClinicExportData',
        component:ClinicExportData,
      },
      { path:'/clinic_patientProfile2',
        component:patientProfile2,
      },
    ]
  },
  {
    path:'/Hcp',
    components:{
      default:Hcp,
      header:HCPHeader,
    },
    children: [
      { path:'/charts',
        component:charts,
        children:[
          { path: '/chart0', component: chart0 ,},
          { path: '/chart1', component: chart1 ,},
          { path: '/chart2', component: chart2_2 ,},
          { path: '/chart3', component: chart3 ,},
          { path: '/chart4', component: chart4 ,},
          { path: '/chart5', component: chart5_2 ,},
          { path: '/chart6', component: chart6 ,},
          { path: '/chart7', component: chart7 ,},
          { path: '/chart8', component: chart8 ,},
          { path: '/chart9', component: chart9 ,}
        ],
      },
      { path:'/chartSetting',
        component:chartSetting,
        children:[
          { path: '/setting', component:setting,},
          { path: '/dateView',component:dateView,},
          { path: '/dateView2',component:dateView2,},
        ],
      },
      { path:'/monitor',
        component:monitor,
      },
      { path:'/events',
        component:events,
      },
      { path:'/records',
        component:records,
      },
      { path:'/print',
        component:print,
      },
      { path:'/patientProfile',
        component:patientProfile,
      },
      { path:'/patientProfile2',
        component:patientProfile2,
      },
      { path:'/patientProfile3',
        component:patientProfile3,
      },
    ]
  },
  {
    path:'/carerConnection',
    components:{
      default:carerConnect,
      header:HCPHeader,
    }
  },
  {
    path:'/addConnection',
    components:{
      default:addConnect,
      header:HCPHeader,
    }
  },
  {
    path:'/connection',
    components:{
      default:patientConnect,
      header:HCPHeader,
    }
  },
  {
    path:'/messages',
    components:{
      default:messages,
      header:HCPHeader,
    }
  },
  {
    path:'/Profile1',
    components:{
      default:Profile1,
      header:HCPHeader,
    }
  },
  {
    path:'/CreateHCP',
    components:{
      default:CreateHCP,
      header:CreateHCPHeader,
    }
  },
  /*{
    path:'/ClinicExportData',
    components:{
      default:ClinicExportData,
      header:CreateHCPHeader,
    }
  },*/
  {
    path:'/recent-updates',
    components:{
      default:RecentUpdates,
      header:HCPHeader,
    }
  },
  {
    path:'/changePassword',
    components:{
      default:changePassword,
      header:HCPHeader,
    }
  },
  {
    path:'/chart0-print',
    components:{
      default:chart0_print,
    }
  },
  {
    path:'/chart1-print',
    components:{
      default:chart1_print,
    }
  },
  {
    path:'/chart2-print',
    components:{
      default:chart2_print,
    }
  },
  {
    path:'/chart3-print',
    components:{
     default:chart3_print,
    }
  },
  {
    path:'/chart4-print',
    components:{
      default:chart4_print,
    }
  },
  {
    path:'/chart5-print',
    components:{
      default:chart5_print,
    }
  },
  {
    path:'/chart6-print',
    components:{
      default:chart6_print,
    }
  },
  {
    path:'/chart6-print2',
    components:{
      default:chart6_print2,
    }
  },
  {
    path:'/chart7-print',
    components:{
      default:chart7_print,
    }
  },
  {
    path:'/events-print1',
    components:{
      default:events_print1,
    }
  },
  {
    path:'/chart9-print',
    components:{
      default:chart9_print,
    }
  },
  {
    path:'/record-print',
    components:{
      default:record_print,
    }
  },

  {
    path:'/quickPrint1',
    components:{
      default:quickPrint1,
    }
  },
  {
    path:'/quickPrint2',
    components:{
      default:quickPrint2,
    }
  },
  {
    path:'/quickPrint3',
    components:{
      default:quickPrint3,
    }
  },
  {
    path:'/quickPrint4',
    components:{
      default:quickPrint4,
    }
  },
  {
    path:'/quickPrint5',
    components:{
      default:quickPrint5,
    }
  },
  {
    path:'/quickPrint6',
    components:{
      default:quickPrint6,
    }
  },
  {
    path:'/quickPrint7',
    components:{
      default:quickPrint7,
    }
  },
  {
    path:'/quickPrint8',
    components:{
      default:quickPrint8,
    }
  },
  {
    path:'/quickPrint9',
    components:{
      default:quickPrint9,
    }
  },
  {
    path:'/quickPrint10',
    components:{
      default:quickPrint10,
    }
  },
  {
    path:'/refresh',
    components:{
      default:refresh,
      header:HCPHeader,
    }
  },
  {
    path:'/updating',
    components:{
      default:()=>import('./components/updating.vue'),
    }
  },
  {
    path:'/error',
    components:{
      default:()=>import('./components/error.vue'),
    }
  },
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes.js